import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import Directory from './components/Nav';
import Register from './components/Register';
import Routines from './components/Routines';
import Activities from './components/Activities';
import Login from './components/Login';
import MyRoutines from './components/MyRoutines';
import './index.css';
import {BrowserRouter as Router,
Route } from 'react-router-dom';
import 
    GetAllRoutines
from './api/Routines';
import GetAllActivities from './api/Activities';
import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {
    
  const [ routine, setRoutine ] = useState([]);
  const [ deletedRoutine, setDeletedRoutine ] = useState([]);
  const [ isPublic, setIsPublic ] = useState(Boolean);
  const [ activity, setActivity ] = useState([]);
  const [ user , setUser ] = useState({});
  const [ token, setToken ] = useState({});
  
  return (
      
      <>
    
    <div id="App" style={{backgroundColor : '#008080',
                          border: '10px double black'
                          }}>
    <div className="jumbotron jumbotron-fluid" style={{backgroundColor : '#95dfe3', border : '3px solid white'}}>
  <div className="container" style={{letterSpacing : '3px'}}>
    <i><b><h1 className="display-4"><i color='#f69284' class="fas fa-burn"></i>&nbsp;Fitness Trac.kr</h1></b></i>
    <p className="lead">LET'S GET TO <b>WORK!</b></p>
  
  </div>
</div>
  
      
      <Route>
      <Directory token={token} setToken={setToken} user={user} setUser={setUser} setRoutine={setRoutine}/>
      </Route>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <Route exact path="/login">
      <Login token={token} setToken={setToken} user={user} setUser={setUser}/>
      </Route>
      <Route exact path="/register">
      <Register token={token} setToken={setToken} user={user} setUser={setUser}/>
      </Route>
      <Route exact path="/routines">
      <Routines activity={activity} setActivity={setActivity} user={user} setUser={setUser} routine={routine} setRoutine={setRoutine} onClick={() => {
          GetAllRoutines()}}
        />
      </Route>
      <Route exact path="/myroutines">
      <MyRoutines deletedRoutine={deletedRoutine} setDeletedRoutine={setDeletedRoutine} activity={activity} isPublic={isPublic} setIspublic={setIsPublic} setActivity={setActivity} user={user} setUser={setUser} token={token} setToken={setToken} routine={routine} setRoutine={setRoutine}
        />
      </Route>
      <Route exact path="/activities">
      <Activities routine={routine} setRoutine={setRoutine} user={user} setUser={setUser} activity={activity} token={token} onClick={() => {
          GetAllActivities()}}
        setActivity={setActivity}/>
      </Route>

      
    </div>
    
    </>
    
    
  );
}

ReactDOM.render(
 <Router>
  <App />,
  </Router>,
  document.getElementById('app')
);